export default __webpack_public_path__ + "static/media/AllProductAdd.34c1735c.svg";